import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { syncedColumns } from './common';

/**
 * Synced. One weigh-in per local day: id = singletonId(userId, 'weight_entries.<YYYY-MM-DD>')
 * (core weight/entries.ts), so logging a day again replaces it. Integer grams, never floats.
 */
export const weightEntries = sqliteTable(
  'weight_entries',
  {
    ...syncedColumns(),
    /** Local day the weigh-in belongs to. */
    date: text('date').notNull(),
    valueG: integer('value_g').notNull(),
    /** The unit it was typed in; screens show every weight in weight_settings.unit. */
    unit: text('unit', { enum: ['kg', 'lb'] })
      .notNull()
      .default('kg'),
    note: text('note'),
    recordedTz: text('recorded_tz').notNull(),
  },
  (t) => [index('weight_entries_user_date_idx').on(t.userId, t.date)],
);

/**
 * Synced. One row per user: id = singletonId(userId, 'weight_settings'). Every column has a
 * default or is nullable, so a write may carry only the fields it sets (partial upsert).
 */
export const weightSettings = sqliteTable('weight_settings', {
  ...syncedColumns(),
  unit: text('unit', { enum: ['kg', 'lb'] })
    .notNull()
    .default('kg'),
  goalG: integer('goal_g'),
  /** The weight progress counts from: the current weight when the goal was set. */
  goalStartG: integer('goal_start_g'),
  goalStartDate: text('goal_start_date'),
});
